<template>
  <div class="container">
    <!-- 顶部 -->
    <van-sticky>
      <div class="top">
        <!-- 搜索 -->
        <van-search v-model="searchValue" shape="round" background="var(--background_color)" :placeholder="$t('public').search" @search="onSearch" @cancel="onSearch" @clear="onSearch" @input="onSearch" />
        <!-- 行情分类 -->
        <div class="proTab"><span v-for="(item, index) in tabsMarket" :key="`tabma${index}`" :class="activeMarket == item.value ? 'active' : ''" @click="changeMarketTab(item.value)">{{ item.name
            }}</span></div>
        <!-- 产品业务 -->
        <div class="protypeTab">
          <div class="left">
            <span v-for="(item, index) in tabsBusiness" :key="`tabbus${index}`" :class="activeBusiness == item.value ? 'active' : ''" @click="changeBusinessTab(item.value)">{{ item.name
              }}</span>
          </div>
          <svg-icon class-name="svgs" icon-class="edit" v-if="activeMarket == 0 && !showAddSelect" @click="$router.push({ name: 'MySelect' })" />
        </div>
        <!-- 产品类型 -->
        <div class="tabs" v-if="(activeBusiness == 2||activeBusiness == 4) && tabsType.length > 2"><span v-for="(item, index) in tabsType" :key="`tabtype${index}`" :class="activeType == item.value ? 'active' : ''"
            @click="changeTypeTab(item.value)">{{ item.name }}</span>
        </div>
        <!-- 产品标题 -->
        <div class="title">
          <div class="name">{{ $t('market').product }}</div><span>{{ $t('market').Latestprice }}</span><span>{{
            $t('market').volume }}</span><span>{{ $t('market').ChangeRatio }}</span>
        </div>
      </div>
    </van-sticky>
    <!-- 添加自选 -->
    <div class="addSelectBtn" v-if="activeMarket == 0 && showAddSelect">
      <van-button block @click="$router.push({ name: 'MySelect', query: { i: true } })">{{ $t('market').Addoptional
      }}</van-button>
    </div>
    <!-- 产品列表 -->
    <div class="productInfo">
      <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="onGetProductList" :immediate-check="false">
        <div class="item" v-for="(item, index) in pList" :key="`pro${index}`" @click="$router.push({ name: 'Kline', query: { id: item.productId } })">
          <div class="name"><img :src="baseUrl + item.logoUrl" />{{ item.name }} </div>
          <span :class="item.priceChangeRatio > 0 ? 'green' : 'red'">{{ item.newPrice }}</span>
          <span>{{ item.volume | formatNumber }}</span>
          <span :class="item.priceChangeRatio > 0 ? 'greenbg' : 'redbg'" class="ratio">{{ item.priceChangeRatio
          }}%</span>
        </div>
      </van-list>
    </div>
    <TabBar active="Market" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import productApi from '@/api/product'
import systemApi from '@/api/system'
import TabBar from '@/components/tabBar'
import { webSocket } from "@/mixins/webSocket.js";
import { Token } from '@/utils/mm'
export default {
  mixins: [webSocket],
  components: {
    TabBar,
  },
  data() {
    return {
      baseUrl: window.baseURL,
      searchValue: '',
      //行情分类
      activeMarket: 1,
      tabsMarket: [{
        name: this.$t('market').market,
        value: 1
      }, {
        name: this.$t('market').optional,
        value: 0
      },],
      //产品业务
      activeBusiness: 1,
      tabsBusiness: [{
        name: this.$t('public').USDTcontract,
        value: 1
      },
      //  {
      //   name: this.$t('public').Fiatcurrencycontract,
      //   value: 2
      // }, 
      {
        name: this.$t('public').spot,
        value: 3
      }, {
        name: this.$t('public').secondContract,
        value: 4
      }],
      //产品类型
      activeType: '',
      tabsType: [{
        name: this.$t('public').All,
        value: ""
      }],
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      pList: [],
      showAddSelect: false,
    }
  },
  computed: {
    ...mapGetters(['basicConfig', 'connection', 'baseMsg']),
  },
  mounted() {
    this.getConfig()
    this.onSearch()
  },
  //销毁之前
  beforeDestroy() {
    this.websockClose();
  },
  methods: {
    // 获取客户端配置 配置支持产品类型
    async getConfig() {
      this.tabsType = [{
        name: this.$t('public').All,
        value: ""
      }]
      const res = await systemApi.getConfig()
      var productType = res.productType.split(',')
      productType.forEach((sItem) => {
        switch (sItem) {
          case "1":
            this.tabsType.push({
              name: this.$t('public').DigitalCurrency,
              value: "1"
            })
            break;
          case "2":
            this.tabsType.push({
              name: this.$t('public').foreignExchange,
              value: "2"
            })
            break;
          case "3":
            this.tabsType.push({
              name: this.$t('public').futures,
              value: "3"
            })
            break;
          case "4":
            this.tabsType.push({
              name: this.$t('public').stockIndex,
              value: "4"
            })
            break;
          case "5":
            this.tabsType.push({
              name: this.$t('public').stock,
              value: "5"
            })
            break;
        }
      })
    },
    //搜索
    onSearch() {
      this.pList = []
      this.parms.pageNum = 1
      this.finished = false;
      this.onGetProductList()
    },
    //获取产品行情/自选列表事件
    onGetProductList() {
      if (this.activeMarket == 0) this.getOptionalProductList()
      if (this.activeMarket == 1) this.getProductList()
    },
    //切换行情分类
    changeMarketTab(val) {
      this.activeMarket = val
      this.onSearch()
    },
    //切换产品业务
    changeBusinessTab(val) {
      this.activeBusiness = val
      if (this.activeBusiness != 2 && this.activeBusiness != 4)
        this.activeType = ''
      this.onSearch()
    },
    //切换产品类型
    changeTypeTab(val) {
      this.activeType = val
      this.onSearch()
    },
    // 获取自选产品列表
    async getOptionalProductList() {
      if (!Token.get()) return
      if (this.isRun) return
      this.isRun = true
      this.parms.productBusiness = this.activeBusiness
      this.parms.productType = this.activeType
      this.parms.name = this.searchValue
      const res = await productApi.getOptionalProductList(this.parms)
      this.pList.push(...res.rows);
      if (this.pList.length > 0)
        this.showAddSelect = false
      else this.showAddSelect = true
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.pList.length >= res.total)
        this.finished = true;
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    // 获取产品列表
    async getProductList() {
      if (this.isRun) return
      this.isRun = true
      this.parms.productBusiness = this.activeBusiness
      this.parms.productType = this.activeType
      this.parms.name = this.searchValue
      const res = await productApi.getProductList(this.parms)
      this.pList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.pList.length >= res.total)
        this.finished = true;
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    //推送
    websocketGet() {
      let that = this
      // 订阅产品给价格赋值
      const subRequest = {
        action: 'SubAdd',
        content: that.pList.map(item => item.symbol)
      };
      that.websockSend(JSON.stringify(subRequest), (reslult) => {
        // 产品列表
        that.pList.forEach((sItem) => {
          let quotes = reslult.find(item => item.Symbol == sItem.symbol);
          if (quotes) {
            sItem.newPrice = quotes.NewPrice
            sItem.volume = quotes.Volume
            sItem.priceChangeRatio = quotes.PriceChangeRatio
          }
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding-bottom: calc(75px + var(--bottom-toolbar-offset, 0px));
  background: var(--background_color);

  .top {
    width: 100%;
    background: var(--background_color);
    padding-top: 10px;

    .proTab {
      padding: 12px 15px;
      font-size: 17px;
      font-weight: bold;
      color: var(--ntext_color);
      border-bottom: 1px solid var(--info_color);

      span {
        margin-right: 20px;
      }

      .active {
        color: var(--text_color);
      }
    }

    .protypeTab {
      padding: 0 15px;
      font-size: 14px;
      font-weight: bold;
      color: var(--ntext_color);
      border-bottom: 1px solid var(--info_color);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        padding: 12px 0;

        span {
          margin-right: 20px;
        }

        .active {
          color: var(--text_color);
          padding-bottom: 10px;
          border-bottom: 2px solid var(--text_color);
        }
      }

      .svgs {
        width: 18px;
        height: 18px;
        color: var(--text_color);
      }
    }

    .tabs {
      display: flex;
      align-items: center;
      color: var(--ntext_color);
      font-size: 13px;
      padding: 8px 15px;
      border-bottom: 1px solid var(--info_color);

      span {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px 10px;
        margin-right: 10px;
      }

      .active {
        background: var(--info_color);
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px 10px;
        color: var(--text_color);
      }
    }

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: var(--ntext_color);
      padding: 0 15px;
      font-size: 12px;
      height: 50px;

      .name {
        width: 30%;
        text-align: left;
      }

      span {
        width: 20%;
        text-align: right;
      }
    }
  }

  .addSelectBtn {
    margin: 100px 15px 85px 15px;

    .van-button {
      margin-top: 20px;
      background: var(--text_color);
      height: 40px;
      border-radius: 20px;
      border: 0;
      font-size: 15px;
      color: var(--background_color);
    }
  }

  .productInfo {
    margin: 0 15px 85px 15px;

    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      color: var(--text_color);
      font-size: 13px;

      .name {
        font-weight: bold;
        width: 30%;
        text-align: left;
        display: flex;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          margin-right: 10px;
        }
      }

      span {
        width: 20%;
        text-align: right;
      }

      .ratio {
        width: 20%;
        padding: 5px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        border-radius: 5px;
      }

      &:active {
        background: var(--info_color);
      }
    }
  }
}

::v-deep .van-search__content {
  background-color: var(--info_color);
}

::v-deep .van-cell {
  color: var(--text_color);
}

::v-deep .van-field__control {
  color: var(--text_color);
}
</style>
